import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllPackagingTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  //States
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);

  //Variables
  const created_between = urlQueries["created_between"] || "";

  const allPackagingTypesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PACKAGING_TYPES,
      page,
      debouncedQuery,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PACKAGING_TYPES,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          page: page,
          per_page: per_page,
          include: "parent,travel_mode",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allPackagingTypesService },
    states: { searchQuery, setSearchQuery },
  };
};
